import React, { createContext, useReducer } from "react";
import { saveFilterStateRouteView } from "../../util/Util";
import { RouteFilterReducer } from "../reducers/RouteFilterReducer";
import { ROUTE_FILTER_STATE_KEY } from "../utils/LocalStoragekeys";
import { ROUTE_VIEW } from "../../util/Constants";
import { PRODUCT_TYPES } from "../utils/ProductTypeUtils";

export const RouteFilterContext = createContext();

const RouteFilterContextProvider = (props) => {
  let initialState = {
    productType: PRODUCT_TYPES.ALL_ROUTES,
    departure: [],
    driverType: [],
    cluster: [],
    viewType: ROUTE_VIEW,
    status: [],
    stageLocationType: [],
    deliverySpeed: [],
    data: {
      departure: [],
      driverType: [],
      cluster: [],
    },
  };
  const urlState = props.context
    ? JSON.parse(props.context.replace("%2f", "/"))
    : null;
  if (urlState) {
    initialState = { ...initialState, ...urlState };
    saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, initialState);
  }

  const [viewModelF, dispatchF] = useReducer(RouteFilterReducer, initialState);
  return (
    <RouteFilterContext.Provider value={{ viewModelF, dispatchF }}>
      {props.children}
    </RouteFilterContext.Provider>
  );
};

export default RouteFilterContextProvider;



// WEBPACK FOOTER //
// ./src/components/RouteStatus/context/RouteFilterContext.js